import _objectSpread from "/data/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 重置 ");

const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 添加 ");

const _hoisted_4 = /*#__PURE__*/_createTextVNode("删除");

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 编辑 ");

const _hoisted_6 = /*#__PURE__*/_createTextVNode("查看");

import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { exportCarouselList } from '@/request/api';
import { getAttractBannerList, delAttractBanner, attractBannerUpdateStatus } from '@/request';
import { getVexTableProps } from '@/config';
import { ElMessage, ElMessageBox } from 'element-plus';
import AddCarouselConfigureModal from './component/AddCarouselConfigureModal.vue';
export default {
  name: 'AttractInvestBanner',

  setup(__props) {
    const store = useStore();
    store.dispatch('getDictList');
    const dictList = computed(() => store.state.dictList);
    const showAddModal = ref(false);
    const form = ref({
      prodName: '',
      title: ''
    });
    const isSee = ref(false);
    const editData = ref(null);
    const table = ref();
    const dataTotal = ref(0);
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'checkbox',
        width: '50px',
        fixed: 'left'
      }, {
        field: 'createBy',
        title: '创建人账号',
        width: '150px',
        showOverflow: true
      }, {
        title: '轮播图',
        slots: {
          default: 'previewImg'
        },
        width: '100px',
        showOverflow: true
      }, {
        title: '页面标题',
        field: 'title',
        width: '150px',
        showOverflow: true
      }, {
        title: '排序',
        field: 'sort',
        width: '150px',
        showOverflow: true
      }, {
        title: '状态',
        field: 'status',
        width: '100px',
        formatter: ({
          cellValue
        }) => cellValue === 1 ? '启用' : '禁用'
      }, {
        title: '投放时间',
        width: '230px',
        formatter: ({
          row
        }) => `${row.startTime || '-'} 至 ${row.endTime || '-'}`
      }, {
        title: '跳转链接',
        field: 'prodName',
        width: '250px',
        showOverflow: true,

        formatter({
          cellValue,
          row
        }) {
          return row.configType === 2 ? '图文介绍' : cellValue || '-';
        }

      }, {
        title: '更新时间',
        field: 'updateAt',
        width: '250px',
        showOverflow: true
      }, {
        title: '操作',
        field: 'operation',
        width: '250px',
        fixed: 'right',
        slots: {
          default: 'operation'
        }
      }],
      toolbarConfig: {
        slots: {
          buttons: 'tools'
        }
      },
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getAttractBannerList(_objectSpread({
              page: page.currentPage,
              pageSize: page.pageSize
            }, form.value)).then(data => {
              res({
                total: data.data.totalSize,
                result: data.data.list
              });
            });
          })
        }
      }
    });

    function reset() {
      form.value = {
        prodName: '',
        title: ''
      };
      table.value.commitProxy('reload');
    }

    function edit(row) {
      isSee.value = false;
      showAddModal.value = true;
      editData.value = row;
    }

    function see(row) {
      isSee.value = true;
      showAddModal.value = true;
      editData.value = row;
    }

    function add() {
      isSee.value = false;
      showAddModal.value = true;
      editData.value = null;
    }

    function changeStatus(row, status) {
      const statusText = status === 1 ? '启用' : '禁用';
      ElMessageBox.confirm(`确认将「${row.title}」${statusText}吗？`, '状态切换').then(() => {
        attractBannerUpdateStatus({}, {
          params: {
            slideConfigId: row.slideConfigId,
            status,
            __warn: true,
            __repeat: true
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function del() {
      // delCarouselConfigure
      const selectRows = table.value.getCheckboxRecords();

      if (!selectRows.length) {
        ElMessage.warning('请勾选后再进行操作!');
        return;
      }

      ElMessageBox.confirm(`是否确认删除${selectRows.length}条数据?`, '删除').then(() => {
        delAttractBanner({
          __warn: true,
          __repeat: true
        }, {
          params: {
            ids: selectRows.map(row => row.slideConfigId).join(',')
          }
        }).then(data => {
          if (data.success) {
            ElMessage.success('操作成功!');
            table.value.commitProxy('query');
          }
        });
      });
    }

    function addSuccess() {
      table.value.commitProxy('query');
      showAddModal.value = false;
    }

    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_form_item = _resolveComponent("el-form-item");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_row = _resolveComponent("el-row");

      const _component_el_form = _resolveComponent("el-form");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_image = _resolveComponent("el-image");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, null, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "页面标题:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.title,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => form.value.title = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 8
          }, {
            default: _withCtx(() => [_createVNode(_component_el_form_item, {
              label: "商品名称:"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: form.value.prodName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => form.value.prodName = $event)
              }, null, 8, ["modelValue"])]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_row, {
        justify: "end"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_button, {
          type: "primary",
          icon: "Search",
          onClick: _cache[2] || (_cache[2] = $event => table.value.commitProxy('reload'))
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          icon: "Refresh",
          onClick: reset
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        tools: _withCtx(() => [_createVNode(_component_el_button, {
          icon: "CirclePlus",
          type: "primary",
          onClick: add
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_el_button, {
          icon: "Delete",
          type: "danger",
          onClick: del
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        previewImg: _withCtx(({
          row
        }) => [_createVNode(_component_el_image, {
          style: {
            "width": "70px",
            "height": "70px"
          },
          src: row.slideshowUrl,
          "preview-src-list": [row.slideshowUrl],
          fit: "cover"
        }, null, 8, ["src", "preview-src-list"])]),
        operation: _withCtx(({
          row
        }) => [_createVNode(_component_el_button, {
          type: row.status === 1 ? 'danger' : 'success',
          onClick: $event => changeStatus(row, row.status === 1 ? 0 : 1)
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(row.status === 1 ? '禁用' : '启用'), 1)]),
          _: 2
        }, 1032, ["type", "onClick"]), _createVNode(_component_el_button, {
          icon: "Edit",
          type: "primary",
          onClick: $event => edit(row)
        }, {
          default: _withCtx(() => [_hoisted_5]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          type: "success",
          onClick: $event => see(row)
        }, {
          default: _withCtx(() => [_hoisted_6]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      }, 16), _createVNode(AddCarouselConfigureModal, {
        modelValue: showAddModal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => showAddModal.value = $event),
        editData: editData.value,
        isSee: isSee.value,
        onSuccess: addSuccess
      }, null, 8, ["modelValue", "editData", "isSee"])]);
    };
  }

};